module.exports = __webpack_public_path__ + "static/video4-48e046f4f95bfba22826c70377545c3e.mp4";